import { render } from "./editStageModal.vue?vue&type=template&id=38981d8a&ts=true"
import script from "./editStageModal.vue?vue&type=script&lang=ts"
export * from "./editStageModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__